import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import callApi from "../../Api";
import {
  formatRegistrationPending,
  formatStudentsList,
  SET_PAYMENT_DUE_LIST,
  SET_REGISTRATION_PENDING_STUDENTS,
  SET_STUDENTS_LIST,
  formatPaymentDueList,
  STUDENT_NOTIFICATION_LIST,
} from "../../redux/actions/studentActions";
import {
  formatNotificationList,
  formatStudentNotifications,
  NOTIFICATION_LIST,
} from "../../redux/actions/notificationAction";
import {
  formatPaymentList,
  PAYMENTS_DATA,
} from "../../redux/actions/paymentAction";
import { ADMIN_REPORTS_DATA } from "../../redux/actions/reportAction";
const AgGridTable = (props) => {
  const {
    rowData,
    columnDefs,
    pagination,
    datasource,
    defaultColDef,
    isPaginationRequired,
    fetchParamsList,
    actionType,
    setAgGridRef,
  } = props;
  console.log(props);
  const [gridApi, setGridApi] = useState(null);
  const [data, setData] = useState([]);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const gridRef = useRef();

  const datasourceData = {
    getRows: async (params) => {
      console.log(JSON.stringify(params, null, 1));
      const { startRow, endRow, filterModel, sortModel } = params;
      const filterKeys = Object.keys(filterModel);
      if (
        pagination.currentPage === 1 &&
        startRow === 0 &&
        sortModel.length === 0 &&
        filterKeys.length === 0
      ) {
        console.log("Success");
        params.successCallback(rowData, pagination.totalItems);
      } else {
        console.log("Failure");
        let reqParams = await fetchParamsList();
        reqParams.page = endRow / pagination.perPage;
        if (sortModel.length) {
          const { colId, sort } = sortModel[0];
          reqParams.sortBy = colId;
          reqParams.orderBy = sort;
        }
        //Filtering
        console.log("Filter Kyes", filterKeys);
        filterKeys.forEach((filter) => {
          // url += `${filter}=${filterModel[filter].filter}&`
          reqParams[`${filter}`] = filterModel[filter].filter;
        });
        let data = {};
        let rows = [];
        let totalItems = 0;
        switch (actionType) {
          case SET_STUDENTS_LIST:
            data = await callApi.get(`student/list`, { params: reqParams });
            totalItems = data.data.data.totalItems;
            rows = formatStudentsList(data.data.data.rows);

            break;
          case SET_REGISTRATION_PENDING_STUDENTS:
            data = await callApi.get(`student/pendingRegistration`, {
              params: reqParams,
            });
            rows = formatRegistrationPending(data.data.data.rows);
            totalItems = data.data.data.totalItems;

            break;
          case SET_PAYMENT_DUE_LIST:
            data = await callApi.get(`student/paymentDue`, {
              params: reqParams,
            });
            rows = formatPaymentDueList(data.data.data.rows);
            totalItems = data.data.data.totalItems;

            break;
          case NOTIFICATION_LIST:
            data = await callApi.get(`notification/list`, {
              params: reqParams,
            });
            rows = formatNotificationList(data.data.data.rows);
            totalItems = data.data.data.totalItems;
            break;
          case PAYMENTS_DATA:
            data = await callApi.get(`payments/list`, { params: reqParams });
            rows = formatPaymentList(data.data.data.rows);
            totalItems = data.data.data.totalItems;
            break;
          case ADMIN_REPORTS_DATA:
            data = await callApi.get(`admin/reportsList`, {
              params: reqParams,
            });
            rows = data.data.data.totalStudents;
            totalItems = data.data.data.totalItems;
            break;
          case STUDENT_NOTIFICATION_LIST:
            data = await callApi.get(`student/notifications`, {
              params: reqParams,
            });
            rows = formatStudentNotifications(data.data.data.rows);
            totalItems = data.data.data.totalItems;
            break;
          case ADMIN_REPORTS_DATA:
            data = await callApi.get(`admin/reportsList`, {
              params: reqParams,
            });
            rows = data.data.data.totalStudents;
            totalItems = data.data.data.totalItems;
            break;

          default:
            params.successCallback([], 0);
            break;
        }
        params.successCallback(rows, totalItems);
      }
    },
  };
  const onGridReady = async (params) => {
    console.log(props.columnDefs, params);
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);

    await params.api.setDatasource(datasourceData);
    if (isPaginationRequired) {
      setAgGridRef(gridRef);
    }
  };
  const components = {
    loading: (params) => {
      console.log(params);
      if (params.value !== undefined) {
        return params.value;
      } else {
        return "<img src='https://www.ag-grid.com/example-assets/loading.gif'/>";
      }
    },
  };
  const getRowId = useCallback(function (params) {
    return params.data.id;
  }, []);
  const rowClassRules = useMemo(() => {
    console.log("Updateaasd");
    return {
      // row style function
      "student-inactive": function (params) {
        console.log(params);
        return params.data && params.data.isInactiveStudent;
      },
      // row style expression
      "sick-days-breach": false,
    };
  }, []);

  return (
    <>
      {isPaginationRequired ? (
        <>
          <div className="ag-theme-alpine" style={{ height: 500 }}>
            <AgGridReact
              ref={gridRef}
              columnDefs={columnDefs}
              enableCellChangeFlash={true}
              // pagination={true}
              // paginationPageSize={8}
              // domLayout="autoHeight"
              rowData={rowData}
              rowModelType="infinite"
              onGridReady={onGridReady}
              cacheBlockSize={pagination.perPage || 20}
              maxConcurrentDatasourceRequests={1}
              infiniteInitialRowCount={1}
              components={components}
              defaultColDef={defaultColDef}
              getRowId={getRowId}
              rowClassRules={rowClassRules}
              {...props}
            />
          </div>
        </>
      ) : (
        <>
          <div style={{ width: "100%", height: "100%" }}>
            <div className="ag-theme-alpine" id="myGrid">
              <AgGridReact
                defaultColDef={defaultColDef}
                columnDefs={columnDefs}
                rowData={rowData}
                onGridReady={onGridReady}
                domLayout="autoHeight"
                {...props}
              ></AgGridReact>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default AgGridTable;
